import React from "react"
import ContenidoNosotros from "../components/ContenidoNosotros"
import Layout from "../components/Layout"

const nosotros = () => {
  return (
    <Layout>
      <ContenidoNosotros />
    </Layout>
  )
}

export default nosotros
